import { Injectable } from '@angular/core';
import { Observable, of, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class CommonSheetsService extends GoogleSheetsBaseService {

  /**
   * Gets a list of US states.
   * @returns An observable of the geographic states list.
   */
  getGeographicStates(): Observable<any> {
    return this.getSheetColumnData('common', 'F2', 'F100').pipe(
      map(response => response || [])
    );
  }

  /**
   * Gets a list of contract status types.
   * @returns An observable of the contract status types.
   */
  getContractStatusTypes(): Observable<any> {
    return this.getSheetData('common', 'B2', 'B50').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of renewal type labels.
   * @returns An observable of the renewal type labels.
   */
  getRenewalTypeLabels(): Observable<any> {
    return this.getSheetData('common', 'D2', 'D50').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of contract types.
   * @returns An observable of the contract types.
   */
  getContractTypes(): Observable<any> {
    return this.getSheetData('common', 'E2', 'E200').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of departments.
   * @returns An observable of the departments list.
   */
  getDepartments(): Observable<any> {
    return this.getSheetData('common', 'C2', 'C300').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of regulatory values.
   * @returns An observable of the regulatory values.
   */
  getRegulatoryValues(): Observable<any> {
    return this.getSheetData('common', 'I2', 'I20').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of database organizations.
   * @returns An observable of the database organizations.
   */
  getDatabaseOrganizations(): Observable<any> {
    return this.getSheetData('common', 'J2', 'J20').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of risk categories.
   * @returns An observable of the risk categories.
   */
  getRiskCategories(): Observable<any> {
    return this.getSheetData('common', 'H2', 'H40').pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of service types.
   * @returns An observable of the service types.
   */
  getServiceTypes(): Observable<any> {
    return this.getSheetData('common', 'H2', 'H40').pipe(
      map(response => response[0] || [])
    );
  }
}